<template>
  <card-dialog
    v-model="modalVisible"
    max-width="400px"
    :title="title"
  >
    <v-card-text class="pa-6">
      {{ text }}
    </v-card-text>
    <template v-slot:actions>
      <v-card-actions class="pa-4">
        <v-spacer />
        <span class="text--secondary caption mr-2">ENTER or</span>
        <v-btn
          color="primary"
          :loading="submitting"
          @click="$emit('confirm')"
        >
          {{ button }}
        </v-btn>
      </v-card-actions>
    </template>
  </card-dialog>
</template>

<script>
import CardDialog from '@/components/helpers/CardDialog'

export default {
  name: 'ConfirmDeleteDialog',
  components: { CardDialog },
  props: {
    text: {
      type: String,
      default: 'Are you sure you want to delete?'
    },
    title: {
      type: String,
      default: 'Confirm delete'
    },
    button: {
      type: String,
      default: 'Yes, delete'
    },
    visible: {
      type: Boolean,
      default: false
    },
    submitting: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    modalVisible: {
      get: function () {
        return this.visible
      },
      set: function (value) {
        this.$emit('update:visible', value)
      }
    }
  },
  watch: {
    visible(value) {
      if (value) {
        window.addEventListener('keyup', this.handleEnter)
      } else {
        window.removeEventListener('keyup', this.handleEnter)
      }
    }
  },
  methods: {
    handleEnter(event) {
      if (!this.modalVisible || event.code !== 'Enter') return

      this.$emit('confirm')
    }
  }
}
</script>

<style scoped>

</style>
